<template>
  <div class="col-12 box-col-6 email-wrap">
    <div class="email-left-aside productlisting mt-5">
      <b-overlay :show="loading" rounded="sm">
        <b-card no-body>
          <b-tabs card>
            <div>
              <b-tab :active="currentTab == 0" :title-link-attributes="{ 't_label': 'EMPBE_ProductInfoCenter_tab_Product' }">
                <div slot="title">
                  {{ $t('Lbl_ProductInfo') }}
                </div>
                <div class="email-app-sidebar left-bookmark" style="height: auto">
                  <div class="media"></div>
                  <ul class="nav main-menu col-12" role="tablist">
                    <li class="nav-item" v-if="productList.length > 1">
                      <div class="badge-light-primary btn-block btn-mail m-b-0">
                        <i class="icofont icofont-listing-number"></i>{{ $t("lbl_EMPBE_DragDropProd") }}
                      </div>
                    </li>
                    <li>
                      <ul v-dragula="productList" service="product" drake="product">
                        <li v-for="(product, index) in productList" :key="product.productId"
                          :id="product.productId">
                          <router-link :to="'/productInfoCenter/productDetail/' + product.productId" router-link-active
                            v-b-toggle="'productRightpopup'" class="p-r-20"
                            v-bind:t_label="'EMPBE_ProductInfoCenter_Product_' + product.id">
                            <span class="title">{{ product.name }}</span>

                            <span class="badge badge-light-info m-r-5 m-l-5 f-16" v-if="product.isFire">
                              <i class="icofont icofont-fire-alt f-16 mr-0"></i>
                              {{ $t('lbl_EMPBE_MainProd') }}
                            </span>

                            <span class="badge badge-warning m-r-5 m-l-5 f-16" v-if="true">
                              <span
                                v-if="product.lastSubmitDate == undefined">{{
                                  $t('lbl_EMPBE_Draft') }}</span>
                            </span>
                            <span v-if="product.lastSubmitDate" class="badge-light-success badge m-r-5 m-l-5 f-16">{{
                              $t('lbl_EMPBE_isActivate') }}</span>

                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </b-tab>
              <b-tab :active="currentTab == 1" :title-link-attributes="{ 't_label': 'EMPBE_ProductInfoCenter_tab_Info' }">
                <div slot="title">
                  {{ $t("lbl_EMPBE_ProductIndex") }}
                </div>
                <div class="email-app-sidebar left-bookmark" style="height: auto">
                  <div class="media"></div>
                  <ul class="nav main-menu col-12" role="tablist">
                    <li class="nav-item" v-if="indexList.length > 1">
                      <div class="badge-light-primary btn-block btn-mail m-b-0">
                        <i class="icofont icofont-listing-number"></i>{{ $t('lbl_EMPBE_DragDropIndex') }}
                      </div>
                    </li>
                    <li>
                      <ul v-dragula="indexList" drake="index">
                        <li v-for="index in indexList" :key="index.id" :id="index.id">
                          <router-link :to="'/productInfoCenter/indexDetail/' + index.id
                            " router-link-active v-b-toggle="'productRightpopup'" class="p-r-20"
                            v-bind:t_label="'EMPBE_ProductInfoCenter_Index_' + index.id">
                            <span class="title">{{ index.name }}</span>

                            <!-- <label class="badge m-r-5 m-l-5 f-16" :class="index.statusClass">{{
                            index.status
                        }}</label> -->
                            <span v-if="index.lastSubmitDate" class="badge-light-success badge m-r-5 m-l-5 f-16">{{
                              $t('lbl_EMPBE_isActivate') }}</span>

                            <span class="badge badge-warning m-r-5 m-l-5 f-16" v-if="true">
                              <span
                                v-if="index.lastSubmitDate == undefined">{{
                                  $t('lbl_EMPBE_Draft') }}</span>
                            </span>

                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </b-tab>
            </div>
          </b-tabs>
        </b-card>

      </b-overlay>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { productService } from '@/_services/product.service';

export default {
  props: ['hideSidebarNavMenu', 'currentTab', 'supplierId', 'productList', 'indexList'],
  data() {
    return {
      loading: false,
      items: [],
      error: null,
      product_PayTotalQty: 0,
      product_TotalQty: 0,
      product_LaunchedCount: 0,
      directory_PayTotalQty: 0,
      directory_TotalQty: 0,
      directory_LaunchedCount: 0,
    };
  },
  computed: {
    ...mapGetters({
      getPaymentItemById: 'paymentItem/getPaymentItemById',
      getCartPaymentItemById: 'paymentItem/getCartPaymentItemById',
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.supplierId === null || this.supplierId === undefined || this.supplierId === '' ? this.user.empCompanyId : this.supplierId;
    },
    langid() {
      return localStorage.getItem("currentLangId")
    }
  },
  created() {
    // watch the params of the route to fetch the data again
    this.$watch(
      () => this.$route.params,
      () => {
        if (!this.fetchedData) {
          this.fetchData();
          this.productListDragula();
        }
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    );
    this.initData();
  },
  mounted() {
    // 监听子组件的刷新事件
    this.$on('fetchData', this.fetchData);
  },

  watch: {
    indexList() {
      // var that = this;
      // that.items = [];
      // console.log(this.langid)
      // that.indexList.forEach(element => {
      //   var data = that.items.filter(c => c.id == element.id);
      //   if (data.length <= 0) {
      //     if (element.langid == this.langid) {
      //       that.items.push(element);
      //     }
      //   }
      // });
      // that.items.forEach(element => {
      //   if (element.name == '') {
      //     var item = that.Records.filter(c => c.id == element.id && c.name != '')[0];
      //     if (item) {
      //       element.name = item.name;
      //     }
      //   }
      //   // element.lastSaveDate = new Date(element.lastSaveDate);
      //   // element.lastSubmitDate = new Date(element.lastSubmitDate)
      // });
    }
  },
  methods: {
    initData() {
      var that = this;
      productService.getSysAccountPaymentInfo({ CompanyId: this.companyid, demodate: '' }).then((res) => {
        if (res.isSuccessful) {
          console.log('res.data');
          console.log(res.data);
          if (res.data != null) {
            let data = res.data;
            if (data.length > 0) {
              data.forEach(element => {
                if (element.rid === 1) {
                  that.product_PayTotalQty = element.payTotalQty + element.totalQty;
                  that.product_TotalQty = element.totalQty;
                }
                if (element.rid === 2) {
                  that.directory_PayTotalQty = element.payTotalQty + element.totalQty;
                  that.directory_TotalQty = element.totalQty;
                }
              });
            }
          }

        }
      });
    },
    productListDragula() {
      let dragula = this.$dragula;
      let service = dragula.createService({
        name: 'product',
        drake: {
          copy: true,
        },
      });
      service.on({
        'product:dropModel': ({
          name,
          el,
          source,
          target,
          dragIndex,
          dropIndex,
          sourceModel,
        }) => {
          el.classList.add('ex-moved');
          if (name == 'product' && dragIndex != dropIndex) {
            var productId = el.attributes.id.value;
            productService
              .saveProdutDetailIndex({
                companyId: this.companyid,
                productId: productId,
                old_index: dragIndex,
                new_index: dropIndex,
              })
              .then((res) => {
                if (res.isSuccessful) {
                  this.$swal({
                    text: this.$t('lbl_EMPBE_ChangeProdOrder'),
                  });
                }
              });
          }
          if (name == 'index' && dragIndex != dropIndex) {
            var catalogId = el.attributes.id.value;
            productService
              .saveProdutCatalogDetailIndex({
                companyId: this.companyid,
                catalogId: catalogId,
                old_index: dragIndex,
                new_index: dropIndex,
              })
              .then((res) => {
                if (res.isSuccessful) {
                  this.$swal({
                    text: this.$t('lbl_EMPBE_ChangeIndexOrder'),
                  });
                }
              });
          }
        },
      });
    },
    fetchData() {
      this.error = this.items = null;
      // this.loading = true;
      this.fetchedData = true;
      // this.loadData();
    },
    loadData() {
      setTimeout(() => {
        this.loading = false;
        //获取数据
        productService
          .getProdutListAsync({ companyId: this.companyid })
          .then((res) => {
            if (res.isSuccessful) {
              this.productList = [];
              this.product_LaunchedCount = 0;
              res.data.forEach((item) => {
                var _item = {
                  id: item.productId,
                  name: this.langid == "1252" ? item.ExhibitNameE : item.exhibitNameS,
                  IsLaunch: item.isLaunch,
                  isFire: item.isMainProduct,
                  EmpCompanyId: item.empCompanyId,
                  OrderId: item.orderId,
                  productId: item.productId,
                  lastSubmitDate: item.lastSubmitDate,
                  lastSaveDate: item.lastSaveDate
                };
                if (_item.name == "") {
                  _item.name = this.langid == "1252" ? item.ExhibitNameS : item.exhibitNameE
                }
                if (_item.IsLaunch) {
                  this.product_LaunchedCount += 1;
                }
                this.productList.push(_item);
              });
            }
          });
        //获取产品目录列表
        productService
          .getProdutCatalogListAsync({ companyId: this.companyid })
          .then((res) => {
            console.log('获取产品目录列表');
            console.log(res);
            if (res.isSuccessful) {
              this.indexList = [];
              this.directory_LaunchedCount = 0;
              res.data.forEach((item) => {
                //var currentLangId = localStorage.getItem('currentLangId');
                var index = this.indexList.filter(c => c.id == item.catalogId);
                if (index.length <= 0) {
                  var _item = {
                    id: item.catalogId,
                    name: item.name,
                    statusClass: item.isLaunch
                      ? 'badge-light-success'
                      : 'badge-light',
                    orederId: item.orderId,
                    spanIsLaunch: item.isLaunch,
                    lastSaveDate: item.saveDate,
                    lastSubmitDate: item.submitDate
                  };
                  if (_item.spanIsLaunch) {
                    this.directory_LaunchedCount += 1;
                  }
                  this.indexList.push(_item);
                }
              });
              console.log('indeli', this.indexList);
            }
          });

      }, 300);
    },
    //Add to cart
    addToCart: function (sku, qty) {
      //close right popup
      this.hideSidebarNavMenu();

      var product = this.getCartPaymentItemById(sku);
      if (product != undefined) {
        this.$store.dispatch('paymentItem/updateCartQuantity', {
          product: product,
          qty: 1,
        });
      } else {
        product = this.getPaymentItemById(sku);
        product.quantity = qty ? qty : 1;
        this.$store.dispatch('paymentItem/addToCart', product);
      }
      this.cart_open();
    },
    cart_open() {
      this.$store.dispatch('paymentItem/toggleCart', true);
    },
  },
};
</script>
<style>
/* .card .router-link-exact-active {
  background-color: #e2e2e2;
  text-decoration: none;
} */

.no-router-link-exact-active {
  background-color: unset !important;
}

.productlisting>a.btn.btn-outline-primary.p-l-15.collapsed {
  display: flex;
  align-items: center;
}</style>